/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetRolePermissionsRequestDto
 */
export interface SetRolePermissionsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SetRolePermissionsRequestDto
     */
    permissionKeys: Array<SetRolePermissionsRequestDtoPermissionKeysEnum>;
}


/**
 * @export
 */
export const SetRolePermissionsRequestDtoPermissionKeysEnum = {
    OrgRelationshipsCreate: 'org-relationships:create',
    OrgRelationshipsRead: 'org-relationships:read',
    OrgRelationshipsUpdate: 'org-relationships:update',
    OrgRelationshipsDelete: 'org-relationships:delete',
    OrganizationsCreate: 'organizations:create',
    OrganizationsRead: 'organizations:read',
    OrganizationsUpdate: 'organizations:update',
    OrganizationsDelete: 'organizations:delete',
    AssetTypesCreate: 'asset-types:create',
    AssetTypesRead: 'asset-types:read',
    AssetTypesUpdate: 'asset-types:update',
    AssetTypesDelete: 'asset-types:delete',
    AssetTypesImport: 'asset-types:import',
    ManufacturersCreate: 'manufacturers:create',
    ManufacturersRead: 'manufacturers:read',
    ManufacturersUpdate: 'manufacturers:update',
    ManufacturersDelete: 'manufacturers:delete',
    AssetModelsCreate: 'asset-models:create',
    AssetModelsRead: 'asset-models:read',
    AssetModelsUpdate: 'asset-models:update',
    AssetModelsDelete: 'asset-models:delete',
    AssetTypeManufacturerModelsCreate: 'asset-type-manufacturer-models:create',
    AssetTypeManufacturerModelsRead: 'asset-type-manufacturer-models:read',
    AssetTypeManufacturerModelsUpdate: 'asset-type-manufacturer-models:update',
    AssetTypeManufacturerModelsDelete: 'asset-type-manufacturer-models:delete',
    SubsystemsCreate: 'subsystems:create',
    SubsystemsRead: 'subsystems:read',
    SubsystemsUpdate: 'subsystems:update',
    SubsystemsDelete: 'subsystems:delete',
    SubsystemsImport: 'subsystems:import',
    ComponentClassesCreate: 'component-classes:create',
    ComponentClassesRead: 'component-classes:read',
    ComponentClassesUpdate: 'component-classes:update',
    ComponentClassesDelete: 'component-classes:delete',
    ComponentClassesImport: 'component-classes:import',
    ComponentTypesCreate: 'component-types:create',
    ComponentTypesRead: 'component-types:read',
    ComponentTypesUpdate: 'component-types:update',
    ComponentTypesDelete: 'component-types:delete',
    EventStatesCreate: 'event-states:create',
    EventStatesRead: 'event-states:read',
    EventStatesUpdate: 'event-states:update',
    EventStatesDelete: 'event-states:delete',
    EventStatesImport: 'event-states:import',
    ParameterNamesCreate: 'parameter-names:create',
    ParameterNamesRead: 'parameter-names:read',
    ParameterNamesUpdate: 'parameter-names:update',
    ParameterNamesDelete: 'parameter-names:delete',
    ParameterNamesImport: 'parameter-names:import',
    AssetTypeSubsystemsRead: 'asset-type-subsystems:read',
    AssetTypeSubsystemsUpdate: 'asset-type-subsystems:update',
    AssetSubsystemComponentClassesRead: 'asset-subsystem-component-classes:read',
    AssetSubsystemComponentClassesUpdate: 'asset-subsystem-component-classes:update',
    AssetSubsystemComponentClassComponentTypesRead: 'asset-subsystem-component-class-component-types:read',
    AssetSubsystemComponentClassComponentTypesUpdate: 'asset-subsystem-component-class-component-types:update',
    AssetsCreate: 'assets:create',
    AssetsRead: 'assets:read',
    AssetsUpdate: 'assets:update',
    AssetsDelete: 'assets:delete',
    AssetsImport: 'assets:import',
    ComponentTwinsRead: 'component-twins:read',
    ComponentTwinsCreate: 'component-twins:create',
    ComponentTwinsUpdate: 'component-twins:update',
    ComponentTwinsDelete: 'component-twins:delete',
    ComponentsRead: 'components:read',
    ComponentsCreate: 'components:create',
    ComponentsUpdate: 'components:update',
    ComponentsDelete: 'components:delete',
    CustomFieldsRead: 'custom-fields:read',
    CustomFieldsUpdate: 'custom-fields:update',
    CustomFieldsDelete: 'custom-fields:delete',
    IncidentsRead: 'incidents:read',
    IncidentsDiagnose: 'incidents:diagnose',
    IncidentsIngest: 'incidents:ingest',
    IncidentsRemoteActions: 'incidents:remote-actions',
    IncidentsOnsiteInterventions: 'incidents:onsite-interventions',
    IncidentsTransitionStatus: 'incidents:transition-status',
    DiagnosticRulesRead: 'diagnostic-rules:read',
    DiagnosticRulesManage: 'diagnostic-rules:manage',
    ReportsIngest: 'reports:ingest',
    ReportsDownload: 'reports:download',
    ReportsRead: 'reports:read',
    ReportsDelete: 'reports:delete',
    DocumentsRead: 'documents:read',
    DocumentsUpload: 'documents:upload',
    DocumentsHitlResolve: 'documents:hitl-resolve',
    SitesCreate: 'sites:create',
    SitesRead: 'sites:read',
    SitesUpdate: 'sites:update',
    SitesDelete: 'sites:delete',
    ZonesCreate: 'zones:create',
    ZonesRead: 'zones:read',
    ZonesUpdate: 'zones:update',
    ZonesDelete: 'zones:delete',
    UsersCreate: 'users:create',
    UsersRead: 'users:read',
    UsersUpdate: 'users:update',
    UsersDelete: 'users:delete',
    PartnersLandlordsRead: 'partners:landlords:read',
    PartnersLandlordsManage: 'partners:landlords:manage',
    PartnersOemsRead: 'partners:oems:read',
    PartnersOemsManage: 'partners:oems:manage',
    PartnersMaintenanceRulesRead: 'partners:maintenance-rules:read',
    PartnersMaintenanceRulesManage: 'partners:maintenance-rules:manage',
    PipelineDebugRun: 'pipeline-debug:run',
    ManualLogUploadUpload: 'manual-log-upload:upload',
    ManualLogUploadClear: 'manual-log-upload:clear',
    ManualLogUploadRun: 'manual-log-upload:run',
    MaintenanceRead: 'maintenance:read',
    MaintenanceManage: 'maintenance:manage',
    WorkOrderRead: 'work-order:read',
    WorkOrderManage: 'work-order:manage',
    PermissionsRead: 'permissions:read',
    RolesRead: 'roles:read',
    RolesCreate: 'roles:create',
    RolesUpdate: 'roles:update',
    RolesDelete: 'roles:delete',
    RolesAssignPermissions: 'roles:assign-permissions',
    UsersAssignRole: 'users:assign-role',
    SessionRead: 'session:read'
} as const;
export type SetRolePermissionsRequestDtoPermissionKeysEnum = typeof SetRolePermissionsRequestDtoPermissionKeysEnum[keyof typeof SetRolePermissionsRequestDtoPermissionKeysEnum];


/**
 * Check if a given object implements the SetRolePermissionsRequestDto interface.
 */
export function instanceOfSetRolePermissionsRequestDto(value: object): value is SetRolePermissionsRequestDto {
    if (!('permissionKeys' in value) || value['permissionKeys'] === undefined) return false;
    return true;
}

export function SetRolePermissionsRequestDtoFromJSON(json: any): SetRolePermissionsRequestDto {
    return SetRolePermissionsRequestDtoFromJSONTyped(json, false);
}

export function SetRolePermissionsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRolePermissionsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionKeys': json['permissionKeys'],
    };
}

export function SetRolePermissionsRequestDtoToJSON(json: any): SetRolePermissionsRequestDto {
    return SetRolePermissionsRequestDtoToJSONTyped(json, false);
}

export function SetRolePermissionsRequestDtoToJSONTyped(value?: SetRolePermissionsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionKeys': value['permissionKeys'],
    };
}

